import { Role, type RoleType } from '@seek/profile-read-ui';
import { Stack } from 'braid-design-system';

interface Props {
  roles: RoleType[];
}
const Roles = ({ roles }: Props) => {
  const roleProps = roles.map((role) => {
    const props = {
      ...role,
      confirmed: true,
      showReviewLink: false,
      showMissingAchievementsText: false,
    };
    return props;
  });
  return (
    <Stack component="ul" space="large">
      {roleProps.map((role) => (
        <Role {...role} key={role.id} />
      ))}
    </Stack>
  );
};
export default Roles;
